'use strict';

import React from 'react';
import { useEffect, useState, useContext } from 'react';

import { Table } from 'react-bootstrap';

import useRequest from '../helper/useRequest';
import { formatDate, formatTime, getDateFromString, getGermanDateFromString } from '../helper/DateTimeFormater';
import { toast } from 'react-toastify';
import useConfirmation from '../helper/Confirmation';
import AppContext from '../AppContext';
import Loader from '../helper/Loader';

import Select from 'react-select';

import {
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    useReactTable,
} from '@tanstack/react-table'

const columnHelper = createColumnHelper();

function Appointments() {
    const { request } = useRequest();
    const context = useConfirmation();
    const { getSalutation } = useContext(AppContext);
    const [periodFilter, setPeriodFilter] = useState({ value: 0, label: "alle" });
    const [sorting, setSorting] = useState([]);
    const [realAppointments, setRealAppointments] = useState(false);
    const [appointments, setAppointments] = useState(false);
    const now = new Date();

    const columns = [
        columnHelper.accessor('Appointment', {
            header: () => <span>Datum</span>,
            cell: info => formatDate(info.getValue()),
            enableColumnFilter: false,
        }),
        columnHelper.accessor('TimeStart', {
            header: () => <span>Startzeit</span>,
            cell: info => {
                return formatTime(info.getValue());
            },
            enableColumnFilter: false,
        }),
        columnHelper.accessor('IntervalTime', {
            header: () => <span>Intervall Zeit</span>,
            cell: info => info.getValue(),
            enableColumnFilter: false,
        }),
        columnHelper.accessor('Email', {
            header: () => <span>E-Mail</span>,
            cell: info => info.getValue(),
            enableColumnFilter: false,
        }),
        columnHelper.accessor('PhoneNo', {
            header: () => <span>Telefonnr.</span>,
            cell: info => info.getValue(),
            enableColumnFilter: false,
        }),
        columnHelper.accessor('SalutationID', {
            header: () => <span>Anrede</span>,
            cell: info => {
                return ((info.row.original.SalutationID == 3) ? "---" : getSalutation(info.row.original.SalutationID))
            },
            enableColumnFilter: false,
        }),
        columnHelper.accessor('FirstName', {
            header: () => <span>Vorname</span>,
            cell: info => info.getValue(),
            enableColumnFilter: false,
        }),
        columnHelper.accessor('LastName', {
            header: () => <span>Nachname</span>,
            cell: info => info.getValue(),
            enableColumnFilter: false,
        }),
        columnHelper.accessor('OrganisationName', {
            header: () => <span>Organisation</span>,
            cell: info => info.getValue(),
            enableColumnFilter: false,
        }),
        columnHelper.accessor('Message', {
            header: () => <span>Nachricht vom Buchenden</span>,
            cell: info => info.getValue(),
            enableSorting: false,
            enableColumnFilter: false,
        }),
        columnHelper.accessor('AppointmentID', {
            size: 120,
            header: () => <span></span>,
            cell: info => {
                let d = getDateFromString(getGermanDateFromString(info.row.original.Appointment), info.row.original.Time);
                if (d < now) return;           
            },
            enableSorting: false,
            enableColumnFilter: false,
        }),
    ]

    const periodList = [
        { value: 0, label: "alle" },
        { value: 1, label: "aktuelle" },
        { value: 2, label: "vergangene" },
    ];

    const t = useReactTable({
        data: appointments || [],
        columns,
        state: {
            sorting,
        },
        onSortingChange: setSorting,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
    })

    const filterAppointments = (realAppointments) => {
        const today = new Date();

        let appointments = [];
        if (periodFilter.value == 0) {
            appointments = realAppointments;
        }
        else if (periodFilter.value == 1) {
            appointments = realAppointments.filter(i => getDateFromString(getGermanDateFromString(i.Appointment)) >= today);
        }
        else if (periodFilter.value == 2) {
            appointments = realAppointments.filter(i => getDateFromString(getGermanDateFromString(i.Appointment)) <= today);
        }

        setAppointments(appointments);
    } 

    useEffect(() => {
        const getAppointments = async () => {
            try {
                let result = await request("/Operator/GetAppointments");
                let json = result.data;
                if (json.r != 1) {
                    if (json.message) {
                        toast.info(json.message);
                    }
                    else {
                        toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                    }
                    setAppointments([]);
                    setRealAppointments([]);
                }
                else {
                    let appointmentBookings = [];
                    for (var i = 0; i < json.appointments.length; i++) {
                        for (var x = 0; x < json.appointments[i].Bookings.length; x++) {
                            var valueToPush = {}; // or "var valueToPush = new Object();" which is the same
                            valueToPush["Appointment"] = json.appointments[i].Appointment;
                            valueToPush["TimeStart"] = json.appointments[i].Bookings[x].TimeStart;
                            valueToPush["IntervalTime"] = json.appointments[i].IntervalTime;
                            valueToPush["Email"] = json.appointments[i].Bookings[x].Email;
                            valueToPush["PhoneNo"] = json.appointments[i].Bookings[x].PhoneNo;
                            valueToPush["SalutationID"] = json.appointments[i].Bookings[x].SalutationID;
                            valueToPush["FirstName"] = json.appointments[i].Bookings[x].FirstName;
                            valueToPush["LastName"] = json.appointments[i].Bookings[x].LastName;
                            valueToPush["OrganisationName"] = json.appointments[i].Bookings[x].OrganisationName;
                            valueToPush["Message"] = json.appointments[i].Bookings[x].Message;
                            appointmentBookings.push(valueToPush);
                            //appointmentBookings.push([json.appointments[i].Date, json.appointments[i].Bookings[x].Time, json.appointments[i].IntervalTime, json.appointments[i].Bookings[x].Email, json.appointments[i].Bookings[x].SalutationID, json.appointments[i].Bookings[x].FirstName, json.appointments[i].Bookings[x].LastName, json.appointments[i].Bookings[x].Message]);
                        }
                    }
                    setRealAppointments(appointmentBookings);
                    filterAppointments(appointmentBookings);
                    if (json.appointments.length == 0) {
                        toast.info("Es wurden keine Termine gefunden.");
                    }
                }
            }
            catch {
                toast.error("Laden der Termine fehlgeschlagen.");
            }
        };
        getAppointments();
    }, []);

    useEffect(() => {
        if (!realAppointments) return;
        filterAppointments(realAppointments);
    }, [periodFilter]);

    if (appointments === false) return <Loader />

    return <>
        <div className='mb-3' style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <div className="mb-2 me-2" style={{ width: "220px" }}>
                <label>Zeitraum</label>
                <Select menuPortalTarget={document.body}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    menuPosition={"fixed"} name="filterPeriod" options={periodList} value={periodFilter} className="basic-multi-select" placeholder="Bitte ausw&auml;hlen" onChange={(values) => { setPeriodFilter(values) }} />
            </div>
        </div>
        <Table striped>
            <thead>
                {t.getHeaderGroups().map(headerGroup => (
                    <tr key={headerGroup.id}>
                        {headerGroup.headers.map(header => {
                            return (
                                <th key={header.id} style={{ width: header.getSize() !== 150 ? header.getSize() : undefined }}>
                                    {header.isPlaceholder
                                        ? null
                                        : (
                                            <div {...{
                                                className: header.column.getCanSort()
                                                    ? 'cursor-pointer select-none'
                                                    : '',
                                                onClick: header.column.getToggleSortingHandler(),
                                            }}>
                                                {flexRender(
                                                    header.column.columnDef.header,
                                                    header.getContext()
                                                )}
                                                {{
                                                    asc: <i className="fa-solid fa-sort-up ms-2"></i>,
                                                    desc: <i className="fa-solid fa-sort-down ms-2"></i>,
                                                }[header.column.getIsSorted()] ?? (header.column.getCanSort() ? <i className="fa-solid fa-sort ms-2"></i> : null)}
                                            </div>
                                        )
                                    }
                                </th>
                            )
                        })}
                    </tr>
                ))}
            </thead>
            <tbody>
                {t.getRowModel().rows.map(row => (
                    <tr key={row.id}>
                        {row.getVisibleCells().map(cell => {
                            return (
                            <td key={cell.id}>
                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                            </td>
                        )}) }
                    </tr>
                ))}
            </tbody>
        </Table>
    </>
}

export default Appointments;